<div fxLayout="column" fxLayoutAlign="center" class="height">
    <div id="file-upload-title-container">
        <H2 matTooltip="{{ 'dialog.upload-files.label.title' | translate: { folderName: 'lallo' } }}">
            {{ 'dialog.upload-files.label.title' | translate: { folderName: 'lallo' } }}
        </H2>
        <button id="close-dialog-button" mat-icon-button (click)="closeDialog()"
            matTooltip="{{ 'general.tooltip.close-dialog' | translate }}" color="warn">
            <mat-icon>clear</mat-icon>
        </button>
    </div>

    <div fxLayout="column" fxFlex="90" fxLayoutAlign="center" class="margin-bottom">
        <mat-card id="file-upload-container" class="height overflow-auto" (click)="fileInput.click()" appDrag
            (files)="filesDropped($event)" [ngClass]="(arrayFiles && arrayFiles.length > 0) ? 'image-back' : ''"
            *ngIf="!uploading">
            <input id="fileInput" type="file" multiple (change)="onFileChanged($event)" #fileInput>
            <div *ngIf="arrayFiles && arrayFiles.length > 0">
                <div class="selected-files-container" *ngFor="let file of arrayFiles">
                    <span>{{file.name}}</span>
                    <mat-icon class="selected-files-remove-file" (click)="removeFile($event, file)">clear</mat-icon>
                </div>
            </div>
            <div *ngIf="!arrayFiles || arrayFiles.length <= 0" class="outer">
                <div class="image">
                    <div class="back-image">
                        <mat-icon>cloud_upload</mat-icon>
                    </div>
                    <div class="div-clicca">
                        <span>{{ 'dialog.upload-files.label.drag-box' | translate }}</span>
                    </div>
                </div>
            </div>
        </mat-card>
        <mat-card id="file-upload-progress-container" *ngIf="uploading" class="height overflow-auto">
            <ng-container *ngIf="currentFile != null && totalFiles != null && arrayFiles[currentFile] != null">
                <div class="upload-count">
                    {{ 'dialog.upload-files.label.upload-count' | translate: { currentFile: currentFile + 1, totalFiles: totalFiles  } }}
                </div>
                <div class="upload-filename">{{ arrayFiles[currentFile].name }}</div>
                <div class="upload-progress-bar-container">
                    <mat-progress-bar class="upload-progress-bar" [color]="'primary'" [mode]="'determinate'"
                        [value]="currentUploadProgress">
                    </mat-progress-bar>
                </div>
            </ng-container>
        </mat-card>
    </div>
    <!--
    <div fxLayout="column" fxFlex="10" fxLayoutAlign="center" class="margin-bottom margin-top">

        <input id="fileInput" type="file" multiple (change)="onFileChanged($event)" #fileInput>
        <button mat-button class="height margin" (click)="fileInput.click()">Cerca</button>

    </div>
    -->
    <div fxLayout="row" fxFlex="10" id="file-upload-action-container">
        <button *ngIf="uploading" mat-button color="warn" class="margin-right" (click)="cancel()"
            [disabled]="uploadingPreview">
            {{ 'general.button.cancel' | translate | uppercase }}
        </button>
        <button mat-button *ngIf="!uploading" [disabled]="!arrayFiles || arrayFiles.length == 0 || uploading"
            color="primary" class="margin-left" (click)="upload()">
            {{ 'general.button.upload' | translate | uppercase }}
        </button>
    </div>
</div>